import React, { useRef } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Oval } from 'react-loader-spinner';
import { Toast } from 'primereact/toast';

import { googleCallBack } from '../../../services/api/auth'

const GoogleRedirect = () => {
    const navigate = useNavigate()
    const toast = useRef(null)

    const sleep = async (milliseconds) => {
        await new Promise(resolve => {
            return setTimeout(resolve, milliseconds)
        })
    }
    
    const getToken = async () => {
        const urlParams = new URLSearchParams(window.location.search)
        const code = urlParams.get('code')

        if (code) {
            const body = { code }
            
            const response = await googleCallBack(body)
            
            if(response.status === 200){
                window.location.href = '/'
            }
            else{

                toast.current.show({severity:'error', detail:response.data.error, life: 3000})
                await sleep(3000)

                navigate('/login')
            }
            
        }
    }

    useEffect(() => {
        getToken()
    }, [])

    return(
        <div className="flex flex-row justify-content-center align-items-center h-screen">
            <Toast ref={toast} />
            <Oval
                height={60}
                width={60}
                color="#000"
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="#000"
            />
        </div>
    )
}

export default GoogleRedirect